module.exports = __webpack_public_path__ + "static/media/KN.a9c51241.png";